/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsFxNativeStyleOptions, FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped, FxIdDomainSettingsFxNativeStyleOptionsToJSON, } from './FxIdDomainSettingsFxNativeStyleOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsFxNativeStyleOptions(json)) {
        return FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyleToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsFxNativeStyleOptions(value)) {
        return FxIdDomainSettingsFxNativeStyleOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsFxNativeStyle.js.map